@if (!isAros && !isPrescriber && !isCCPS) {
  <h2>Supporting documents</h2>
}
@if (isCCPS) {
  <h5>Supporting documents</h5>
}
<div style="display: inline-block">
  @if (downloading) {
    <app-spinner [light]="true" [small]="true"></app-spinner>
  }
</div>
<div class="row">


  @for (proof of supportingDocs; track proof) {
    <div class="col-md-6">
      <div class="flexi">
        @if (!isAros && !isPrescriber && !isCCPS) {
          <h5>
            {{ attachmentType[proof.type] | caseSplit}}
          </h5>
        }
        @if (isCCPS) {
          <h6>
            {{ attachmentType[proof.type] | caseSplit}}
          </h6>
        }
        <button class="download-button" [disabled]="downloading" [class.disabled]="downloading">
          <a (click)="download(proof)" [class.disabled]="downloading">
            <i [class]="getIcon(proof)"></i>
            <div class="filename">{{proof.filename}}</div>
            <i class="fa fa-download"></i>
          </a>
        </button>
      </div>
      @if (!isStudent && !isRTR) {
        <div class="form-group">
          <div class="form-control readonly">Company name: {{ proof.certifier.companyName }}</div>
          <div class="form-control readonly">Date: {{ proof.certifier.date | date:'dd/MM/yyyy' }}</div>
          <div class="form-control readonly">Name: {{ proof.certifier.name }}</div>
          <div class="form-control readonly">Number: {{ proof.certifier.number }}</div>
          <div class="form-control readonly">Expiry Date: {{ proof.expiryDate | date:'dd/MM/yyyy' }}</div>
        </div>
      }
    </div>
  }

</div>